export const HEARTBEAT_EVENT = 'HEARTBEAT';

export const HEARTBEAT_INTERVAL = 15000;

export const HEARTBEAT_TIMEOUT = HEARTBEAT_INTERVAL + 5000;
